import * as React from 'react';
import ErrorTemplate from '../templates/ErrorTemplate';
import { NextPage } from 'next';

export type Props = {
  statusCode: number;
};
const CustomError: NextPage<Props> = ({ statusCode }) => {
  return <ErrorTemplate statusCode={statusCode} />;
};

CustomError.getInitialProps = async (contextData) => {
  const { res, err } = contextData;
  const statusCode = res?.statusCode ?? err?.statusCode ?? 404;
  return { statusCode };
};

export default CustomError;
